// AHA-46654 — sidebar Trash points at the workspace app's merged trash
// (/trash inside the aha-workspace embed: presentation bins + ahafiles file
// bins, surveys included) instead of the legacy presentations-only
// /apps/trash-bin. Staging-first rollout: flip the flag in Unleash, no deploy.
export const WORKSPACE_TRASH_FLAG = 'AHA-46654-workspace-trash-sidebar'

// Gate on the variant name, never on enabled/disabled: a boolean check cannot
// distinguish "control" from "the flag failed to load", and treating the latter
// as control corrupts the Mixpanel exposure split. Only an explicit TREATMENT
// retargets the entry; every other value (including a missing flag, which
// getVariant reports as `disabled`) keeps the legacy trash-bin.
export const WORKSPACE_TRASH_VARIANTS = {
  TREATMENT: 'treatment',
  CONTROL: 'control',
}
